import type { NavigationItem, QueryOptions } from '@/types';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import client from './client';
import { API_ENDPOINTS } from './client/api-endpoints';

export function useNavigationMenu(options?: Partial<QueryOptions>) {
  const { locale } = useRouter();

  const formattedOptions = {
    ...options,
    language: 'en',
  };

  const { data, isLoading, error } = useQuery<NavigationItem[], Error>(
    [API_ENDPOINTS.NAVIGATION_CATEGORY_MENU, formattedOptions],
    () => client.navigationMenu.all(formattedOptions),
    {
      // staleTime: Infinity,
      // cacheTime: Infinity,
    },
  );

  return {
    items: data ?? [
      {
        id: 1,
        slug: 'home',
        name: 'Home',
        icon: null,
        url: '/',
        parent: null,
        items: [],
      },
    ],
    isLoading,
    error,
  };
}
